import { useRef, useEffect, DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import { clsx } from '@components/Provider';
import { LoadingThumbnail } from '@assets';

interface Props
  extends Omit<
    DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
    'src' | 'className'
  > {
  src?: string;
  className?: string;
  classes?: {
    root: string;
  };
  height?: number | string | undefined;
  width?: number | string | undefined;
}

const Img = ({ src, className, classes, ...rest }: Props) => {
  const target = useRef<HTMLImageElement>(null);

  const intersect = (
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver
  ) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
    });
  };

  useEffect(() => {
    let observer: IntersectionObserver;

    if (target.current) {
      observer = new IntersectionObserver(intersect);

      observer.observe(target.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <img
      {...rest}
      ref={target}
      style={{
        backgroundImage: `url(${LoadingThumbnail})`,
        ...(rest.style ?? {})
      }}
      alt={rest.alt ? rest.alt : ''}
      src={src}
      onLoad={(e) => (e.currentTarget.style.backgroundImage = 'none')}
      loading="lazy"
      className={clsx(
        'CapaImage-root',
        classes?.root ? classes?.root : className
      )}
    />
  );
};

export default Img;
